module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/400.cced4e96.png";